<template>
    <div class="popup_overlay px-4">
    <div class="custom_dialog rounded-xl" style="width: 1000px; overflow-y: auto; overflow-x: hidden; min-height: 92%; max-height: 92%;">
      <div class="relative">
        <div class="bg-primary flex justify-between p-3 sticky top-0" style="z-index: 100">
          <div class=" font-medium text-white heading-3">
            Edit Address
          </div>
          </div>
          <div style="" class="">
            <div class="p-4">
              <div class="relative">
                <TextField class="pb-2"
                  :inputId="'address2'"
                  :showcharLimit="false"
                  :inputext="location"
                  :placholderText="`Search Address`"
                  :lableText="'Search address'"
                  :autoFocus="false"
                  @inputChangeAction="(data) => { if (!isSelectingPlace) location = data }"  />
                <div class="card p-2 absolute z-10 bg-white w-full max-w " style="display: revert;" v-if="isSshowSelection && searchResults.length > 0" v-click-outside="closeList">
                  <span v-for="(result, i) in searchResults" :key="i" @click="saveLocation(result, i)" class="  ">
                    <div class="flex hover:bg-gray-100 cursor-pointer py-2">
                      <div class="items-center grid w-14 mr-2">
                        <div class="text-center">
                          <i class="fas fa-map-marker-alt text-primary pr-3 pl-2"></i>
                        </div>
                        <div class="heading-7 text-center text-gray3">
                          {{ getDistance(parseInt(result.distance_meters)) }}
                        </div>
                      </div>

                      <div>
                        <div class="cursor-pointer text-text1 font-semibold">{{result.structured_formatting.main_text}}</div>
                        <div class="cursor-pointer text-text2">{{result.structured_formatting.secondary_text}}</div>
                      </div>
                    </div>
                    <div class="dividerLight my-1"></div>
                  </span>
                </div>
            </div>
          </div>
          <div v-if="center !== null" class="p-4 ">
            <GmapMap
              id="map-canvas"
              @click='mark'
              :center="center"
              :zoom="16"
              map-type-id="terrain"
              style="width: 100%; height: 300px">
              <gmap-marker
                :position="center"></gmap-marker>
                <GmapCircle
                  v-for="(pin, index) in markers"
                  :key="index"
                  :center="pin.position"
                  :radius="addressObj.selectedRadius"
                  :visible="true"
                  :options="{fillColor:'#ff000000',strokeColor: 'red',fillOpacity:1.0}"
                ></GmapCircle>
            </GmapMap>
            <div class="px-4 pt-2 pb-0">
              <p class="text-primary italic flex items-center">
                <!-- <i class="fas fa-info-circle mr-2"></i> -->
                Click on the map to select or adjust the address location
              </p>
            </div>
          </div>
          <div v-if="center !== null" class="p-4" style="max-width: 100%; overflow-wrap: break-word;">
            <div v-if="addressObj.fullAddress !== ''" style="max-width: 100%;">
              <p class="text-text2 heading-4" style="word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">{{addressObj.fullAddress}}</p>
            </div>
            <div v-if="addressObj.fullAddress === '' && addressObj.addressLine1 !== ''" style="max-width: 100%;">
              <p class="text-text2 heading-4" style="word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">{{addressObj.addressLine1}}, {{ addressObj.addressLine2 }}</p>
            </div>
              <div class="mb-4">
                <div class="label_css pb-2">Address Title:</div>
                <div >
                  <span @click="changeVal('home')" class="ChipCss heading-6 mr-2" :class="selectedVal === 'home' ? 'bg-primary text-white' : ''">
                    Home
                  </span>
                  <span @click="changeVal('office')" class="ChipCss heading-6 mr-2" :class="selectedVal === 'office' ? 'bg-primary text-white' : ''">
                    Office
                  </span>
                  <span @click="changeVal('other')" class="ChipCss heading-6" :class="selectedVal === 'other' ? 'border border-primary' : ''">
                    <span v-if="selectedVal !== 'other'">{{ CustomVal}}</span>
                    <input id="otherField" v-if="selectedVal === 'other'" v-model="CustomVal" class=" bg-white rounded text-text1 ring-0 outline-none border border-white">
                  </span>
                </div>
              </div>
                <!-- <div v-if="showAdditional" class="sm:grid grid-cols-2 gap-4 my-4">
                   <Dropdown 
                    :inputext="addressObj.radiusDispText" 
                    :inputId="'jobloactioninput'"
                    :lableText="'Requires user to be withis (mtr/mi) from the location'"
                    :placholderText="`Select job location`"
                    :autoFocus="false"
                    :showPlus="false"
                    :showArrow="true"
                    :setReadOnly="true"
                    :searchCallApi="false"
                    :keyName="'displayName'"
                    :listId="'radiusdlist'"
                    :items="radiusList"
                    @selectNewForVal="slectRadius"
                    />
                </div> -->
                <div class="sm:grid grid-cols-2 gap-4 mb-4">
                    <div class="mb-4 sm:mb-0">
                        <TextField
                            :inputId="'housenumid'"
                            :inputext="addressObj.houseNo"
                            :placholderText="`House/Office number`"
                            :lableText="'House/Office number'"
                            :autoFocus="false"
                            @inputChangeAction="(data) => addressObj.houseNo = data"  />
                    </div>
                    <div class="mb-4 sm:mb-0">
                        <TextField
                            :inputId="'floornameeid'"
                            :inputext="addressObj.floorNumber"
                            :placholderText="`Floor number`"
                            :lableText="'Floor number'"
                            :autoFocus="false"
                            @inputChangeAction="(data) => addressObj.floorNumber = data"  />
                    </div>
                    <div class="mb-4 sm:mb-0 col-span-2">
                        <TextField
                            :inputId="'buildingName'"
                            :inputext="addressObj.buildingName"
                            :placholderText="`Apartment/Building name`"
                            :lableText="'Apartment/Building name'"
                            :autoFocus="false"
                            @inputChangeAction="(data) => addressObj.buildingName = data"  />
                    </div>
                    <div class="mb-4 sm:mb-0 col-span-2">
                        <TextAreaInput
                      :inputId="'howtoreach'"
                      :inputext="addressObj.directionNote"
                      :placholderText="`e.g. take first exit from express way`"
                      :lableText="'How to reach'"
                      :inputType="'text'"
                      :autoFocus="false"
                      :textMaxlength="100"
                      :showcharLimit="true"
                      :cols="50"
                      :rows="1"
                      :setReadOnly="false"
                      @inputChangeAction="(data) => addressObj.directionNote = data"  />
                       
                    </div>
                </div>
                <div v-if="showAdditional" class=" sm:grid grid-cols-2 gap-4">
                  <div class="mb-4 sm:mb-0">
                    <TextField
                      :inputId="'contactnameinput'"
                      :inputext="addressObj.contactName"
                      :placholderText="`Contact Name`"
                      :lableText="'Contact Name'"
                      :autoFocus="false"
                      :textMaxlength="25"
                      @inputChangeAction="(data) => addressObj.contactName = data"  />
                  </div>
                  <div class="mb-4 sm:mb-0">
                   <NumberInput
                    :showcharLimit="true"
                    :inputId="'addrescontactnumbid'"
                    :inputext="addressObj.contactNumber"
                    :textMaxlength="12"
                    :placholderText="`Contact Number`"
                    :lableText="'Contact Number'"
                    :inputType="'text'"
                    :autoFocus="false"
                    :fieldError="errObj.contacNumErr !== ''"
                    :setReadOnly="false"
                    @keyPressAction="errObj.contacNumErr = ''"
                    @blurAction="checkContactNumber('prime')"
                    @inputChangeAction="(data) => addressObj.contactNumber = data"  />

                  <p class="text-error heading-7">{{errObj.contacNumErr}}</p>
                  </div>
                </div>
          </div>
        </div>
          <div class="sticky bottom-0 bg-white w-full border-t border-gray-200 py-3 px-4">
            <div class="flex  justify-end gap-4">
              <p class="heading-6 text-gray-600">
                This address will be updated to the selected customer
              </p>

              <div class="flex gap-2 items-center">
                <Button
                  :btnSize="'medium'"
                  :textColor="'text1'"
                  :btnColor="'gray1'"
                  :btnText="'Discard'"
                  @buttonAction="discard()"
                />
                <Button
                  :btnSize="'medium'"
                  :disabled="center === null || addressObj.fullAddress.trim() === ''"
                  :textColor="'white'"
                  :btnColor="'success'"
                  :btnText="`Save`"
                  @buttonAction="saveNewAddress()"
                />
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
/* global google */
import Vue from 'vue'
import GmapCircle from 'vue2-google-maps/dist/components/circle'
import * as VueGoogleMaps from 'vue2-google-maps'
import Button from '@/View/components/globalButton.vue'
// import Dropdown from '@/View/components/dropdown.vue'
import NumberInput from '@/View/components/number-text-field.vue'
// import MyJobApp from '@/api/MyJobApp.js'
import TextAreaInput from '@/View/components/textAreaInput.vue'
import TextField from '@/View/components/textfield.vue'
import { checkSpeialChar } from "@/utils/validation.js";
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDtUhdlkZkpjvqshoWvgaSXYPJZjZi01IQ',
    libraries: 'places,drawing' // necessary for places input
  }
})
export default {
  components: {
    GmapCircle,
    NumberInput,
    Button,
    TextAreaInput,
    TextField,
    // Dropdown,
  },
  data: () => ({
    googleSessionToken: '',
    isSshowSelection: false,
    location: '',
    searchResults: [],
    service: null, // will reveal this later
    isSelectingPlace: false,
    addressSearch: '',
    placesService: null,
      markers: [],
      showMap: false,
      autocompleteOptions: {
        lat: 0,
        lng: 0
      },
      mapOptions: {
        center: { lat: 10.365365, lng: -66.96667 },
        clickableIcons: false,
        streetViewControl: false,
        panControlOptions: false,
        gestureHandling: 'cooperative',
        mapTypeControl: false,
        zoomControlOptions: {
          style: 'SMALL'
        },
        zoom: 14
      },
      selectedVal: '',
      CustomVal: 'Other',
      addressObj: {
        customerAddressId: 0,
        customerId: 0,
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        latitude: '',
        longitude: '',
        fullAddress: '',
        houseNo: '',
        floorNumber: '',
        buildingName: '',
        directionNote: '',
        selectedRadius: 0,
        contactNumber: '',
        contactName: '',
        radiusDispText: '',
        addressTitle: '',
        },
        center: {lat:10, lng:10},
        address: '',
        radiusList: [
          {displayName: 'Anywhere', value: 0},
          {displayName: '10 meters', value: 10},
          {displayName: '20 meters', value: 20},
          {displayName: '30 meters', value: 30},
          {displayName: '40 meters', value: 40},
          {displayName: '50 meters', value: 50},
          {displayName: '100 meters', value: 100},
          {displayName: '500 meters', value: 500},
          {displayName: '1 km', value: 1000},
          {displayName: '2 km', value: 2000},
          {displayName: '3 km', value: 3000},
        ],
        radiusDispText: 'Anywhere',
        errObj: {
          contacNumErr: ''
        },
  }),
  metaInfo () {
    return {
      script: [{
        src: `https://maps.googleapis.com/maps/api/js?key=AIzaSyBlsZw88Ok2PrtzHRu0Ape4gsNr0elVpjk&libraries=places`,
        async: true,
        defer: true,
      }]
    }
  },
  props: ['jobDetail', 'showAdditional'],
   created() {
  },    
  mounted () {
    console.log('jobDetailjobDetailjobDetailjobDetailjobDetailjobDetailjobDetailjobDetail', this.jobDetail);
    if (this.jobDetail.fullAddress === '') {
      this.location = this.jobDetail.addressLine1
    } else {
      this.location = this.jobDetail.fullAddress
    }
    
    const marker = {
      lat: this.jobDetail.latitude,
      lng: this.jobDetail.longitude
    }
    this.center = marker
    this.markers = []
    this.markers.push({ position: this.center })
    for (let index = 0; index < this.radiusList.length; index++) {
      if (this.radiusList[index].value === this.jobDetail.geofenceRangeDiameter) {
        this.addressObj.radiusDispText = this.radiusList[index].displayName
        this.radiusDispText = this.radiusList[index].displayName
      }
    }
    this.addressObj.selectedRadius = this.jobDetail.geofenceRangeDiameter ? this.jobDetail.geofenceRangeDiameter : 0
    this.addressObj.customerAddressId =  this.jobDetail.jobAddressId ? this.jobDetail.jobAddressId : 0
    this.addressObj.customerId = this.jobDetail.customerId ? this.jobDetail.customerId : 0
    this.addressObj.addressLine1 = this.jobDetail.addressLine1 ? this.jobDetail.addressLine1 : ''
    this.addressObj.addressLine2 = this.jobDetail.addressLine2 ? this.jobDetail.addressLine2 : ''
    this.addressObj.city = this.jobDetail.city ? this.jobDetail.city : ''
    this.addressObj.state = this.jobDetail.state ? this.jobDetail.state : ''
    this.addressObj.zip = this.jobDetail.zip ? this.jobDetail.zip : ''
    this.addressObj.country = this.jobDetail.country ? this.jobDetail.country : ''
    this.addressObj.latitude = this.jobDetail.latitude ? this.jobDetail.latitude : 0
    this.addressObj.longitude = this.jobDetail.longitude ? this.jobDetail.longitude : 0
    this.addressObj.fullAddress = this.jobDetail.fullAddress ? this.jobDetail.fullAddress : ''
    this.addressObj.houseNo = this.jobDetail.houseNo ? this.jobDetail.houseNo : ''
    this.addressObj.floorNumber = this.jobDetail.floorNumber ? this.jobDetail.floorNumber : ''
    this.addressObj.buildingName = this.jobDetail.buildingName ? this.jobDetail.buildingName : ''
    this.addressObj.directionNote = this.jobDetail.directionNote ? this.jobDetail.directionNote : ''
    this.addressObj.contactNumber = this.jobDetail.contactNumber ? this.jobDetail.contactNumber : ''
    this.addressObj.contactName = this.jobDetail.contactName ? this.jobDetail.contactName : ''
    this.addressObj.addressTitle = this.jobDetail.addressTitle ? this.jobDetail.addressTitle : ''
    if (this.jobDetail.addressTitle !== '') {
      if (this.jobDetail.addressTitle === 'home') {
        this.selectedVal = 'home'
      } else if (this.jobDetail.addressTitle === 'office') {
        this.selectedVal = 'office'
      } else {
        this.selectedVal = 'other'
        this.CustomVal = this.jobDetail.addressTitle
      }
    } else {
      this.selectedVal = ''
    }
    document.body.style = 'overflow: hidden;'
    if (parseInt(this.$route.params.customerId) > 0) {
      this.addressObj.customerId =  parseInt(this.$route.params.customerId)
    }
    setTimeout(() => {
      document.getElementById('auto-complete-address').focus()
    }, 500);
    this.showMap = true

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.autocompleteOptions = {
          lat : position.coords.latitude,
          lng : position.coords.longitude,
        }
      })
    }
    else {
      alert('Geolocation is not supported in this browser')
    }

    if (window.google && window.google.maps && window.google.maps.places) {
      this.MapsInit()
    } else {
      window.initMap = () => { this.MapsInit() }
    }
    // this.placesService = new google.maps.places.PlacesService(
    //   document.getElementById('map-canvas') || document.createElement('div')
    // );
  },
  watch: {
    location (newValue) {
      if (this.isSelectingPlace) {
        this.isSshowSelection = false   // <-- important
        return
      }
      
      setTimeout(() => {
        this.MapsInit()
        if (newValue.length > 0) {
          this.service.getPlacePredictions({
            input: this.location,
            origin: new google.maps.LatLng( this.autocompleteOptions.lat, this.autocompleteOptions.lng ),
            location: new google.maps.LatLng( this.autocompleteOptions.lat, this.autocompleteOptions.lng ),
            radius: 800
          }, this.displaySuggestions)
        } else {
          this.searchResults = []
        }
      }, 100);
    },
  },
  methods: {
    changeVal (data) {
      this.selectedVal = data
      if (this.CustomVal === '') {
        this.CustomVal = 'other'
      }
      if (data === 'other') {
        setTimeout(() => {
          document.getElementById('otherField').focus()
        }, 200);
      }
    },
    closeList () {
      this.isSshowSelection = false
    },
    // Helper to get valid start coordinates
    getStartCoordinates() {
      if (this.autocompleteOptions.lat && this.autocompleteOptions.lng) {
        return { lat: this.autocompleteOptions.lat, lng: this.autocompleteOptions.lng }
      } else if (this.center) {
        return { lat: this.center.lat, lng: this.center.lng }
      }
      return null // fallback
    },
    async saveLocation (data) {
      if (!data || !data.place_id) return;

      this.isSshowSelection = false;
      this.searchResults = [];

      // Initialize the PlacesService if not already
      if (!this.placesService) {
        this.placesService = new window.google.maps.places.PlacesService(
          new window.google.maps.Map(document.createElement('div'))
        );
      }

      try {
        const placeDetails = await this.getPlaceDetails(data);
        if (!placeDetails) return;

        // Compute distance from start coordinates
        const startCoords = this.getStartCoordinates();
        if (startCoords && placeDetails.geometry?.location) {
          const distanceMeters = this.computeDistance(
            startCoords,
            {
              lat: placeDetails.geometry.location.lat(),
              lng: placeDetails.geometry.location.lng()
            }
          );
          placeDetails.distance = (distanceMeters / 1000).toFixed(2) + ' km';
        } else {
          placeDetails.distance = 'N/A';
        }

        this.setPlace(placeDetails);

      } catch (error) {
        console.error('Error fetching place details:', error);
      }
    },
    getPlaceDetails (choice) {
      return new Promise((resolve, reject) => {
        if (!this.placesService) return reject('PlacesService not initialized');

        this.placesService.getDetails(
          { placeId: choice.place_id },
          (result, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              resolve(result);
            } else {
              reject(`PlacesServiceStatus not OK: ${status}`);
            }
          }
        );
      });
    },
    MapsInit () {
      this.service = new window.google.maps.places.AutocompleteService()
      // Initialize PlacesService for fetching place details and calculating distances
      if (!this.placesService) {
        this.placesService = new window.google.maps.places.PlacesService(
          document.getElementById('map-canvas') || document.createElement('div')
        )
      }
    },
    displaySuggestions(predictions, status) {
      if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
        this.searchResults = [];
        this.isSshowSelection = false;
        return;
      }

      const startCoords = this.getStartCoordinates();
      if (!startCoords) {
        this.searchResults = predictions.map(p => ({
          ...p,
          distance_meters: null,
          structured_formatting: p.structured_formatting || this.fallbackFormatting(p)
        }));
        this.isSshowSelection = true;
        return;
      }

      // Reset with null distance
      this.searchResults = predictions.map(p => ({
        ...p,
        distance_meters: null,
        structured_formatting: p.structured_formatting || this.fallbackFormatting(p)
      }));
      this.isSshowSelection = true;

      // Map by place_id → immune to async order problems
      const resultByPlaceId = new Map();
      this.searchResults.forEach(item => resultByPlaceId.set(item.place_id, item));

      predictions.forEach(prediction => {
        this.placesService.getDetails(
          { placeId: prediction.place_id, fields: ['geometry.location'] },
          (place, status) => {
            const item = resultByPlaceId.get(prediction.place_id);
            if (!item) return;

            if (status === google.maps.places.PlacesServiceStatus.OK && place?.geometry?.location) {
              const loc = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
              };
              const distanceMeters = this.computeDistance(startCoords, loc);

              this.$set(item, 'distance_meters', distanceMeters);
            } else {
              this.$set(item, 'distance_meters', null);
            }
          }
        );
      });
    },
    fallbackFormatting(prediction) {
      const parts = prediction.description.split(', ');
      return {
        main_text: parts[0] || '',
        secondary_text: parts.slice(1).join(', ')
      };
    },
    computeDistance(a, b) {
      const R = 6371e3; // meters
      const toRad = x => (x * Math.PI) / 180;

      const dLat = toRad(b.lat - a.lat);
      const dLon = toRad(b.lng - a.lng);

      const lat1 = toRad(a.lat);
      const lat2 = toRad(b.lat);

      const x =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;

      return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
    },
    getDistance(distanceMeter) {
      if (isNaN(distanceMeter)) return '--'
      const isUS = navigator.languages?.[0]?.startsWith('en-US') || false
      const miles = distanceMeter * 0.00062137
      const km = distanceMeter / 1000

      if (isUS) {
        return miles >= 1000 ? '999+ mi' : `${miles.toFixed(1)} mi`
      } else {
        return km >= 1000 ? '999+ km' : `${km.toFixed(1)} km`
      }
    },
    mark (event) {
      let newAddress = ''
      var geocoder = new google.maps.Geocoder;
      var latlng = {lat: event.latLng.lat(), lng: event.latLng.lng()};
      geocoder.geocode({'location': latlng}, function(results, status) {
        if (status === 'OK') {
          if (results[1]) {
            newAddress = results[1].formatted_address
          } else {
            window.alert('No results found');
          }
        }
      })
      this.center = {
        lat: latlng.lat,
        lng: latlng.lng
      }
      this.markers = []
      if (this.showAdditional) {
        this.markers.push({ position: this.center })
      }
      setTimeout(() => {
      this.isSelectingPlace = true
        this.location = newAddress
        this.$nextTick(() => {
          this.isSelectingPlace = false
        })        
        this.addressObj.fullAddress = newAddress
        this.addressObj.latitude = event.latLng.lat()
        this.addressObj.longitude = event.latLng.lng()
      }, 500);
    },
    checkContactNumber () {
      // if (this.addressObj.contactNumber.length < 10 && this.addressObj.contactNumber !== '') {
      //     this.errObj.contacNumErr = 'Please enter valid contact number'
      // } else if (this.addressObj.contactNumber.length === 10 && this.addressObj.contactNumber.trim() !== '' || this.contactNumber.trim() === '') {
      //     this.errObj.contacNumErr = ''
      // }
      let value = checkSpeialChar(this.addressObj.contactNumber)
      if (value) {
        this.errObj.contacNumErr = 'Please enter valid contact number'
      } else {
        this.errObj.contacNumErr = ''
      }
    },
    slectRadius (data) {
      if (data !== null) {
        this.addressObj.selectedRadius = data.value
        this.addressObj.radiusDispText = data.displayName
      } else {
        this.addressObj.selectedRadius = 0
        this.radiusDispText = 'Anywhere'
      }
    },
    discard () {
      document.body.style = 'overflow: visible;'
      this.$root.$emit('EditAddressHandler', false, null)
    },
    saveNewAddress () {
      let isValid = true
      if (this.showAdditional && this.errObj.contacNumErr !== '') {
        isValid = false
      }
      if (isValid) {
        if (this.selectedVal === 'other') {
          this.addressObj.addressTitle = this.CustomVal
        } else {
          this.addressObj.addressTitle = this.selectedVal
        }
        document.body.style = 'overflow: visible;'
        this.$root.$emit('EditAddressHandler', true, this.addressObj)
      }
    },
    setPlace (place) {
      this.isSelectingPlace = true
      this.location = place.formatted_address
      setTimeout(() => {
        this.isSelectingPlace = false
      }, 300)
      let places= []
      if (place) {
         this.markers = []
        this.center = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
        }
        if (this.showAdditional) {
          this.markers.push({ position: this.center })
        }
        places.push(place)
      }
      let detailData = places
      this.addressObj.latitude = place.geometry.location.lat()
      this.addressObj.longitude = place.geometry.location.lng()
      // this.addressObj.street = ''
      this.addressObj.state = ''
      this.addressObj.country = ''
      this.addressObj.zip = ''
      this.addressObj.city = ''
      let mapAddressDetails = []
      let type = ''
      for (let i = 0; i < detailData.length; i++) {
        mapAddressDetails = detailData[i].address_components
        for (let j = 0; j < mapAddressDetails.length; j++) {
          type = mapAddressDetails[j].types[0]
          // if (type === 'street_number' || type === 'sublocality_level_2' || type === 'sublocality' || type === 'sublocality_level_1' || type === 'route') {
          //   this.addressObj.street += ' ' + mapAddressDetails[j].long_name
          // }
          if (type === 'administrative_area_level_1') {
            this.addressObj.state = mapAddressDetails[j].short_name
          }
          if (type === 'administrative_area_level_2') {
            this.addressObj.country = mapAddressDetails[j].long_name
          }
          if (type === 'postal_code') {
            this.addressObj.zip = mapAddressDetails[j].long_name
          }

          if (type === 'locality') {
            this.addressObj.city = mapAddressDetails[j].long_name
          }
        }
      }
      this.addressObj.addressLine1 = place.name
      let space = place.name !== '' ? ', ' : ''
      this.addressObj.fullAddress = place.name + space + place.formatted_address
    },
  },
  beforeDestroy () {
    // this.$root.$off('closeProfileDialog')
  }
}
</script>
<style scoped>
.dividerLight { border-top: 1px solid #eee; }
</style>